import { DataGrid } from "@mui/x-data-grid";

export default function CustomizedDataGrid({
  rows,
  columns,
  loading = false,
  pageSize,
  checkboxSelection = false,
  onRowClick,
  rowCount,
  page,
  handlePageChange,
  handleRowsPerPageChange,
}) {
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      loading={loading}
      checkboxSelection={checkboxSelection}
      onRowClick={onRowClick}
      getRowId={(row) => row.id}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
      }
      pagination
      paginationMode="server"
      rowCount={rowCount}
      paginationModel={{
        page: page - 1, 
        pageSize,
      }}
      onPaginationModelChange={(model) => {
        if (model.page + 1 !== page) {
          handlePageChange(model.page + 1);
        }

        if (model.pageSize !== pageSize) {
          handleRowsPerPageChange(model.pageSize);
        }
      }}
      pageSizeOptions={[10, 20, 50]}
      disableColumnResize
      density="compact"
      autoHeight
      sx={{
        border: 0,
        cursor: onRowClick ? "pointer" : "default",
      }}
      slotProps={{
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: "outlined",
              size: "small",
            },
            columnInputProps: {
              variant: "outlined",
              size: "small",
              sx: { mt: "auto" },
            },
            operatorInputProps: {
              variant: "outlined",
              size: "small",
              sx: { mt: "auto" },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: "outlined",
                size: "small",
              },
            },
          },
        },
      }}
    />
  );
}